import apiClient from './client';

export const authApi = {
  getAuthStatus: async (token) => {
    const response = await apiClient.get('/auth/status', {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
    return response.data;
  },

  getMe: async (token) => {
    const response = await apiClient.get('/auth/me', {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  checkHealth: async () => {
    const response = await apiClient.get('/ready');
    const data = response.data;
    return {
      status: data.status === 'ready' ? 'healthy' : data.status,
      database_connected: data.dependencies?.database ?? false,
    };
  },
};
